import React, { useState } from 'react';
import { Button, Icon } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { MonthsFilter } from 'components/DashboardSettings/MonthsFilter/MonthsFilter';
import { Drawer } from 'components/Drawer/Drawer';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { ColumnSettings } from './ColumnSettings/ColumnSettings';
import styles from './DashboardSettings.module.css';
import { ManagedByIwocaSwitch } from './ManagedByIwocaSwitch/ManagedByIwocaSwitch';

export const DashboardSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { checkIntroducerPermission } = useIntroducerContext();

  const handleToggle = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <>
      <Button
        data-testid="dashboard-settings-toggle-button"
        onClick={handleToggle}
        variant="tertiary"
        className={styles.toggleButton}
      >
        <Icon icon="gearOutline" className={styles.icon} />
        <Trans>Dashboard settings</Trans>
      </Button>

      <Drawer show={isOpen} onClose={handleToggle}>
        <MonthsFilter />
        <hr className={styles.divider} />
        {checkIntroducerPermission('can_see_partner_applications') && (
          <>
            <ManagedByIwocaSwitch />
            <hr className={styles.divider} />
          </>
        )}
        <ColumnSettings />
      </Drawer>
    </>
  );
};
